module.exports = __webpack_public_path__ + "img/pageType3.22697fe9.png";